import { render, staticRenderFns } from "./MoblieCard.vue?vue&type=template&id=4b882698&scoped=true"
import script from "./MoblieCard.vue?vue&type=script&lang=js"
export * from "./MoblieCard.vue?vue&type=script&lang=js"
import style0 from "./MoblieCard.vue?vue&type=style&index=0&id=4b882698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b882698",
  null
  
)

export default component.exports